<template>
  <div class="animated fadeIn">

    
    <b-card class="card-accent-info" header="Grupos de Acesso">
      <b-card-body>

        <b-row>
          <b-col cols="auto" class="mr-auto">
            <!--
              <b-form-group>
                  <b-button variant="outline-primary" :pressed.sync="tableSelectable">{{tableSelectable ? 'Desabilitar Seleção ' : 'Habilitar Seleção'}}</b-button>
                  &nbsp;
                  <b-button variant="outline-primary" v-show="tableSelectable" @click="selectAllRows">Selecionar todos</b-button>
                  &nbsp;
                  <b-button variant="outline-primary" v-show="tableSelectable" @click="clearSelectedRows">Limpar seleção</b-button>
            </b-form-group>
            -->
          </b-col>
          <b-col cols="auto" class="">
            <b-form-group>
              <b-button variant="vine" class="mr-1 btn-brand" @click="enableDisable()"  v-show="tableSelectable"><i class="fa fa-toggle-on"></i><span>Alterar Status</span></b-button>
              &nbsp;
              <b-button variant="vine" class="mr-1 btn-brand" @click="enableBlank()"><i class="fa fa-toggle-on"></i><span>Habilitar Grupos</span></b-button>
              &nbsp;
              <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Novo Grupo de Acesso</span></b-button>
            </b-form-group>
          </b-col>
        </b-row>
            
        <b-row>
          <b-col cols="auto">
              <b-form-group>
                  <label for="company" style="font-size: 0.8em">Empresa</label>
                  <b-form-select id="company"
                    v-model="filters.companyId"
                    :plain="true"
                    :options="companyDDL"
                    :value="[null,'c']">
                  </b-form-select>
              </b-form-group>
          </b-col>
          
          <b-col cols="auto">
            <b-form-group>
                <label for="name">Filtro</label>
                <b-form-input v-model="filters.key" type="text" id="filter" placeholder="Filtro"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
            <b-form-group>
              <p></p>
              <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="refreshData()"><i class="fa fa-search"></i><span>Localizar</span></b-button>
            </b-form-group>
          </b-col>

          <!--
          <b-col cols="auto" class="mr-auto">
            <b-form-group>
                <label for="name">Filtro</label>
                <b-form-input type="text" id="filter" placeholder="Filtro"></b-form-input>
            </b-form-group>
          </b-col>
        -->
          <b-col cols="auto" class="">
            <b-form-group >
                <label for="perPage">Linhas</label>
                <b-form-select v-model="perPage" id="perPage"
                  :plain="true"
                  :options="[5,10,20,50]">
                </b-form-select>
              </b-form-group>
          </b-col>
          
        </b-row>
      

          <b-table
              :items="filteredItems"
              :fields="fields"
              :select-mode="selectMode"
              responsive="sm"
              ref="selectableTable"
              selectable
              @row-selected="onRowSelected"
              :primary-key="primaryKey"
              :tbody-transition-props="transProps"
              sort-icon-left
              @row-clicked="rowClicked"
              :per-page="perPage"
              :current-page="currentPage"
              :busy="isBusy"
              hover
              striped

              >

              <template #table-busy>
                  <div class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Carregando...</strong>
                  </div>
              </template>
              
              <!-- Example scoped slot for select state illustrative purposes -->
              <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                  <span aria-hidden="true">&check;</span>
                  <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                  <span aria-hidden="true">&nbsp;</span>
                  <span class="sr-only">Not selected</span>
                  </template>
              </template>

              <template #cell(show_details)="row">
                  <b-row>
                      <b-col cols="auto" class="mr-auto">
                          <b-form-group>
                          <b-button size="sm" variant="dark"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                          <b-button size="sm" variant="primary"  @click="row.toggleDetails" class="mr-1 btn-brand"><i class="fa fa-file-pdf-o"></i></b-button>
                          </b-form-group>
                      </b-col>
                  </b-row>
              </template>
              
              <template v-slot:cell(st)="data">
                  <c-switch class="" @change.native="changeStatusClick(data.item)" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> 
              </template>
              
          </b-table>
          <nav>
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Anterior" next-text="Próximo" />
          </nav>


      </b-card-body>
   </b-card>


   <b-modal
            v-model="editModal"
            id="edit-modal"
            centered
            hide-footer
            title="Grupo de Acesso"
            size="lg">


          <b-nav fill>
            <b-nav-item :active="tabInfo=='G'" @click="tabInfo='G'">Grupo</b-nav-item>
            <b-nav-item :active="tabInfo=='A'" @click="tabInfo='A'">Acessos</b-nav-item>
            <b-nav-item :active="tabInfo=='C'" @click="tabInfo='C'">Empresas</b-nav-item>
          </b-nav>


          <div v-show="tabInfo=='C'">
            <b-card>

                <b-form @submit.stop.prevent="onSubmit">
                  <div class="animated fadeIn">

                    <b-form-group
                    description=""
                    label="Empresa"
                    label-for=""
                    :label-cols="3"
                    :horizontal="true">
                    <!--
                    <multiselect v-model="selectedGroups" :options="groupddl" :multiple="true" label="label" track-by="label"></multiselect>
                    -->
                    <v-select v-model="selectedCompanies" multiple :options="companyDDL" placeholder="Selecionar empresas" label="text"></v-select>
                  </b-form-group>
                  
                  <div class="text-right">
                    <b-button variant="github" class="mr-1 btn-brand" @click="addCompany(selectedItem.id)"><i class="fa fa-check"></i><span>Incluir Empresa</span></b-button>  
                  </div>

                  <p></p>
                    
                    
                <b-row>
                  <b-col md="12">
                  
                    <b-table :items="companyItems" :fields="companyFields" :select-mode="companySelectMode" responsive="sm" :primary-key="primaryKey" :tbody-transition-props="transProps" sort-icon-left 
    
                    per-page="50" current-page="1" :busy="isBusyCompany" hover striped>
    
                      <template #table-busy>
      
                        <div class="text-center text-danger my-2">
      
                            <b-spinner class="align-middle"></b-spinner>
      
                            <strong>Carregando...</strong>
      
                        </div>
                      </template>
                                    
                      <!-- Example scoped slot for select state illustrative purposes -->
                      <template #cell(selected)="{ rowSelected }">
                          <template v-if="rowSelected">
                          
                                            <span aria-hidden="true">&check;</span>
                          
                                            <span class="sr-only">Selected</span>
                      </template>
                      <template v-else>
                          <span aria-hidden="true">&nbsp;</span>
                          
                          <span class="sr-only">Not selected</span>
                      </template>
                                    </template>

                      
                      <template v-slot:cell(action)="data">
                        <!--<c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> -->
                        <b-button size="sm" variant="danger" @click="deleteGroupCompany(selectedItem.id, data.item.companyId)" class="mr-1 btn-brand"><i class="fa fa-close"></i></b-button>
                      </template>

                                    
                                    
                    </b-table>
                    
                  </b-col>
                </b-row>

              </div>
              </b-form>
            </b-card>
          </div>



          <div v-show="tabInfo=='A'">
            <b-card>

              <b-form @submit.stop.prevent="onSubmit">
              <div class="animated fadeIn">

                <b-form-group
                description=""
                label="Acesso"
                label-for=""
                :label-cols="3"
                :horizontal="true">
                <!--
                <multiselect v-model="selectedGroups" :options="groupddl" :multiple="true" label="label" track-by="label"></multiselect>
                -->
                <v-select v-model="selectedAccesses" multiple :options="selectAccessDDL" placeholder="Selecionar acessos" label="text"></v-select>
              </b-form-group>
               
              <div class="text-right">
                <b-button variant="github" class="mr-1 btn-brand" @click="addAccess(selectedItem.id)"><i class="fa fa-check"></i><span>Incluir Acessos</span></b-button>  
              </div>

              <p></p>

               <!--
                <b-row>
                  <b-col cols="auto" class="mr-auto">
                  
                  </b-col>
                  <b-col cols="auto" class="">
                    <b-form-group>
                      <b-button variant="github" class="mr-1 btn-brand" @click="openAccessModal(null)"><i class="fa fa-plus"></i><span>Novo Acesso</span></b-button>
                    </b-form-group>
                  </b-col>
                </b-row>
                   --> 
                    
                <b-row>
                  <b-col md="12">
                    <b-table :items="accessItems" :fields="accessFields" :select-mode="accessSelectMode" responsive="sm" :primary-key="primaryKey" :tbody-transition-props="transProps" sort-icon-left
                    per-page="50" current-page="1" :busy="isBusyAccess" hover striped>
    
                      <template #table-busy>
      
                        <div class="text-center text-danger my-2">
      
                            <b-spinner class="align-middle"></b-spinner>
      
                            <strong>Carregando...</strong>
      
                        </div>
                      </template>
                                    
                      <!-- Example scoped slot for select state illustrative purposes -->
                      <template #cell(selected)="{ rowSelected }">
                          <template v-if="rowSelected">
                          
                                            <span aria-hidden="true">&check;</span>
                          
                                            <span class="sr-only">Selected</span>
                      </template>
                      <template v-else>
                          <span aria-hidden="true">&nbsp;</span>
                          
                          <span class="sr-only">Not selected</span>
                      </template>
                                    </template>

                      
                      <template v-slot:cell(action)="data">
                        <b-button size="sm" variant="danger" @click="deleteGroupAccess(selectedItem.id, data.item.accessId)" class="mr-1 btn-brand"><i class="fa fa-close"></i></b-button>
                      </template>

                                    
                                    
                    </b-table>
                    
                  </b-col>
                </b-row>

              </div>
              </b-form>
            </b-card>
          </div>



          <div v-show="tabInfo=='G'">
            <b-card>

              <b-form @submit.stop.prevent="onSubmit">

              <div class="animated fadeIn">
            
                <!--
                <b-row>
                  <b-col md="12">
                    
                    <b-form>
                      <b-form-group
                      description=""
                      label="Id"
                      label-for="id"
                      :label-cols="3"
                      :horizontal="true">
                      <b-row>
                        <b-col cols="4">
                          <b-form-input v-model="selectedItem.id" id="id" type="text" readonly></b-form-input>
                        </b-col>
                      </b-row>
                    </b-form-group>          
                    </b-form>
                    </b-col>
                </b-row>
                -->

                <b-row>
                  <b-col md="12">
                    
                    <b-form>
                      <b-form-group
                      description=""
                      label="Grupo de acesso"
                      label-for="name"
                      :label-cols="3"
                      :horizontal="true">
                      <b-form-input v-model="selectedItem.name" id="name" type="text"></b-form-input>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col md="12">
                    <b-form>
                      <b-form-group
                      description=""
                      label="Descrição"
                      label-for="description"
                      :label-cols="3"
                      :horizontal="true">
                      <b-form-textarea
                        id="textarea"
                        v-model="selectedItem.description"
                        placeholder=""
                        rows="3"
                      ></b-form-textarea>
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                <b-input-group class="mb-4">
                    <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
                </b-input-group>
              
                <div slot="footer" class="text-right">
                  <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='I'"><i class="fa fa-times"></i><span>Habilitar</span></b-button>
                  <!-- 
                    <b-button variant="html5" class="mr-1 btn-brand" @click="enableDisable()" v-show="this.selectedItem.id && this.selectedItem.st=='A'"><i class="fa fa-times"></i><span>Desabilitar</span></b-button>
                  -->
                  <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Grupo de Acesso</span></b-button>
                  <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="closeEditModal()"><i class="fa fa-window-close"></i><span>Fechar</span></b-button>

                </div>
                      
              </div>
              </b-form>
            </b-card>
          </div>

    </b-modal>

  </div>

</template>

<script>
import Vue from 'vue'
import axios from "axios";

import { Switch as cSwitch } from '@coreui/vue'
import vSelect from 'vue-select'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
//import { table } from 'console'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

const newItem = {id: null, name: '', description: '', st: 'A', _rowVariant: ''}

export default {
  name: 'tables',
  components: {
    Event,
    cSwitch,
    vSelect
  },
  data: () => {
    return {
       // Tabela Acessos

       selectedAccesses: null,
       accessDDL: [],
       selectedCompanies: null,

       isBusyAccess: false,
        accessItems: [],
        accessFields: [
          { key: 'accessCode', label: 'Código', sortable: true, thStyle: { width: "80px" } },
          { key: 'module.name', label: 'Módulo', sortable: true },
          { key: 'accessName', label: 'Acesso', sortable: true },
          { key: 'action', label: '', sortable: false, thStyle: { width: "40px" } }
        ],
        accessSelectMode: 'single',

          // Tabela Empresas
          isBusyCompany: false,
        companyItems: [],
        companyFields: [
          { key: 'companyName', label: 'Empresa', sortable: true },
          { key: 'action', label: '', sortable: false, thStyle: { width: "40px" } }
        ],
        companySelectMode: 'single',

      tabInfo: 'G',

      isBusy: false,
      currentPage: 1,
      switchLabelIcon: {
          dataOn: '\u2713',
          dataOff: '\u2715'
      },
      switchLabelTxt: {
          dataOn: 'yes',
          dataOff: 'no'
      },

      tableRef: "table",
      tableSelectable: false,
      errorMessage: '',
      editModal: false,
      filters: {
        key: '',
        companyId: 0
      },
      companyDDL: [],
      modes: ['multi', 'single', 'range'],
      selectMode: 'multi',
      selected: [],
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      primaryKey: "id",

      selectedItem: newItem,
      items: [        
      ],
      fields: [
        //{key: 'show_details', label: "", thStyle: { width: "100px" } },
        //{key: 'id' },
        {key: 'name', label: 'Grupo de Acesso', sortable: true, thStyle: { width: "400px" } },
        {key: 'description', label: 'Descrição', sortable: true },
        //{key: 'ispublic', label: 'Público', sortable: true, thStyle: { width: "40px" } },
        {key: 'st', label: 'Status', sortable: true, thStyle: { width: "40px" } }
      ],
      
      filterable: ['username'],
      sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
      perPage: 20
    }
  },
  computed: {
    selectAccessDDL: function() {
      var list = [...this.accessDDL]
      list = list.sort((a,b) => (a.text > b.text) ? 1 : -1)
      //list.unshift({ value: '0' , text: '- Todos -' })
      return list
    },
    totalRows: function () { return this.getRowCount() },
    filteredItems() {
      try {
          return this.items.filter(item => {
            return this.filters.key == '' || item.name.toLowerCase().indexOf(this.filters.key.toLowerCase()) > -1
          })
      }
      catch(e) {
          return this.items;
      }
    }
  },
  methods: {
    getRowCount: function () {
        if(this.items)
            return this.items.length
        else
            return 0;
      },
    
    changeStatusClick(item) {
        if(item != null) {
          if(item.st == 'A') 
            item.st = 'I'; 
          else 
            item.st = 'A';

          this.saveItem(item);
        }
      },

    async saveItem(currentItem) {

      var s = this;
      var isNewGroup = !currentItem.id;
      var postData = { ...currentItem };

      postData.uid = this.$store.state.currentUser.id;
      postData.sid = this.$store.state.currentUser.sid;

      await axios.post(
          this.$store.state.ws_url + "/group",
          postData
      ).then(function(resp) {
          // Mantém a janela aberta tanto ao incluir quanto ao alterar, para
          // permitir vincular Acessos/Empresas sem perder o contexto.
          if(isNewGroup && resp.data.obj) {
            s.selectedItem.id = resp.data.obj
            s.tabInfo = 'A'
            s.getGroupAccess(s.selectedItem.id)
            s.getGroupCompanies(s.selectedItem.id)
          }

          toast({
              type: VueNotifications.types.success,
              title: 'Grupo',
              message: isNewGroup ? 'Grupo criado. Inclua os acessos e empresas do grupo.' : 'Grupo alterado com sucesso.',
              timeout: 5000
          })

          s.refreshData();
      }).catch(function(error) {
          toast({
              type: VueNotifications.types.warn,
              title: 'Grupo',
              message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
              timeout: 5000
          })
      });

    },

    save() {
        if (this.selectedItem.name.length > 0) {
          this.saveItem(this.selectedItem);
        } else {
            toast({
                type: VueNotifications.types.error,
                title: 'Grupo',
                message: 'Favor preencher os campos obrigatórios.',
                timeout: 3000
            })
        }
    },
    enableDisable() {
      console.log('Habilitando/desabilitando grupo de acesso')
      console.log(this.selectedItem);
    },
    closeEditModal() {
      this.editModal = false;
    },
    openEditModal(item) {
      this.tabInfo = 'G'
      if(item == null) {
          this.selectedItem = newItem;      
      }
      else {
          this.selectedItem = JSON.parse(JSON.stringify(item));
      }
      this.getGroupAccess(this.selectedItem.id)
      this.getGroupCompanies(this.selectedItem.id)
      this.editModal = true;
    },
    onRowSelected(items) {
      this.selected = items
      //console.log(items);
      //this.openEditModal(items[0])
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelectedRows() {
      this.$refs.selectableTable.clearSelected();
    },
    rowClicked(item) {
      if(!this.tableSelectable) {
          this.clearSelectedRows();
          this.openEditModal(item);
      }
    },
    getBadge (status) {
      return status === 'A' ? 'primary'
          : status === 'I' ? 'danger'
          : status === 'Pending' ? 'warning'
              : status === 'Banned' ? 'danger' : 'primary'
    },
    toggleBusy() {
      this.isBusy = !this.isBusy
    },

    async deleteGroupCompany(groupId, companyId) {
        var s = this;
        var currentUser = this.$store.state.currentUser
        //console.log('Excluir empresa')
        //console.log(this.$store.state.ws_url + "/group/company?groupId=" + groupId + "&companyId=" + companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid)
        
        await axios.delete(
            this.$store.state.ws_url + "/group/company?groupId=" + groupId + "&companyId=" + companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function() {
            s.getGroupCompanies(groupId)     
          }
        ).catch(function (error) {
          toast ({
            type: VueNotifications.types.warn,
            title: 'Excluir Empres do Grupo',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })
          
        });
        
      },

      async addGroupCompany(currentItem, groupId) {

        //console.log(currentItem);

        var s = this;
        
        //console.log('Salvando usuário')
        
        await axios.post(
            this.$store.state.ws_url + "/group/company",
            currentItem
        ).then(function() {
          s.getGroupCompanies(groupId)
            
          }
        ).catch(function (error) {
          toast ({
            type: VueNotifications.types.warn,
            title: 'Inclusão de Empresa ao Grupo',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })
          
        });
        
      },

      async enableBlank() {
        var s = this;
        var currentUser = this.$store.state.currentUser
        
        await axios.get(
            this.$store.state.ws_url + "/group/user/adjust?uid=" + currentUser.id + "&sid=" + currentUser.sid
        ).then(
          function(resp) {
            toast ({
              type: VueNotifications.types.info,
              title: 'Grupos X Usuários',
              message: 'Usuários ajustados.',
              timeout: 5000
            })
            s.dangerModal = false
            s.refreshData()
          }
        ).catch(function (error) {
          toast ({
            type: VueNotifications.types.error,
            title: 'Grupos X Usuários',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })
          
        });
      },

      addCompany(groupId) {
          
        if(this.selectedCompanies && this.selectedCompanies.length > 0) {
          var groupArray = []
          var currentUser = this.$store.state.currentUser
          this.selectedCompanies.forEach(function(item) {
            groupArray.push( { groupId: groupId, companyId: item.value, uid: currentUser.id, sid: currentUser.sid  } )
          })
          this.addGroupCompany(groupArray, groupId)
        }
        else {
          toast ({
                    type: VueNotifications.types.error,
                    title: 'Grupos',
                    message: 'Nenhuma empresa selecionada',
                    timeout: 3000
                })
        }
      },

    async getGroupCompanies(groupId) {
      var s = this;
      var currentUser = this.$store.state.currentUser;
      await axios.get(
          this.$store.state.ws_url + "/group/company?groupId=" + groupId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          
      ).then(function(resp) {
        s.companyItems = resp.data.obj;
      })
      .catch(function (error) {
        console.log(error);
      });
      
    },

    async deleteGroupAccess(groupId, accessId) {
        var s = this;
        var currentUser = this.$store.state.currentUser
        
        await axios.delete(
            this.$store.state.ws_url + "/group/access?groupId=" + groupId + "&accessId=" + accessId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function() {
            s.getGroupAccess(groupId)     
          }
        ).catch(function (error) {
          toast ({
            type: VueNotifications.types.warn,
            title: 'Excluir Empres do Grupo',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })
          
        });
        
      },

      async addGroupAccess(currentItem, groupId) {

        var s = this;

        await axios.post(
            this.$store.state.ws_url + "/group/access",
            currentItem
        ).then(function() {
          s.getGroupAccess(groupId)
            
        }).catch(function (error) {
          toast ({
            type: VueNotifications.types.warn,
            title: 'Inclusão de Acessos ao Grupo',
            message: error.response && error.response.data && error.response.data.message ? error.response.data.message : 'Sem permissão de acesso.',
            timeout: 5000
          })
          
        });
        
      },

      addAccess(groupId) {
          
        if(this.selectedAccesses && this.selectedAccesses.length > 0) {
          var groupArray = []
          var currentUser = this.$store.state.currentUser

          this.selectedAccesses.forEach(function(item) {
            groupArray.push( { groupId: groupId, accessId: item.value, uid: currentUser.id, sid: currentUser.sid  } )
          })

          this.addGroupAccess(groupArray, groupId)
        }
        else {
          toast ({
                    type: VueNotifications.types.error,
                    title: 'Acessos',
                    message: 'Nenhum acesso selecionado',
                    timeout: 3000
                })
        }
      },


    async getGroupAccess(groupId) {
      var s = this;
      var currentUser = this.$store.state.currentUser;
      await axios.get(
          this.$store.state.ws_url + "/group/access?groupId=" + groupId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
          
      ).then(function(resp) {
        s.accessItems = resp.data.obj;
      })
      .catch(function (error) {
        console.log(error);
      });
      
    },

    async getAccess() {
      var s = this;
      var currentUser = this.$store.state.currentUser;

      //console.log(this.$store.state.ws_url + "/access/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid)

      await axios.get(
          this.$store.state.ws_url + "/access/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
          
      ).then(function(resp) {
        s.accessDDL = resp.data.obj;
      })
      .catch(function (error) {
        console.log(error);
      });
      
    },

    async refreshData() {
  
      var s = this;
      var currentUser = this.$store.state.currentUser;
      this.companyDDL = this.$store.state.currentUser.companies
      
      await axios.get(
          this.$store.state.ws_url + "/group?companyId=" + s.filters.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
      ).then(function(resp) {
        s.items = resp.data.obj
      })
      this.isBusy = false;
      
    }
  },
  mounted: function() {
    this.filters.companyId =  this.$store.state.currentUser.companyId;
    this.isBusy = true;
    this.getAccess();
    this.refreshData();
  }
}
</script>

<style scoped>
table#table-transition-example .flip-list-move {
transition: transform 1s;
}
</style>